import { makeStyles, createStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => createStyles({
  root: {
    background: theme.palette.common.black,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    color: theme.palette.common.white,
  },
  mainInfo: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
    },
  },
  boxInfo: {},
  socialButton: {},
  separator: {
    background: theme.palette.common.white,
    margin: theme.spacing(1),
  },
  hiddenCNPJ: {
    color: 'transparent',
    minWidth: theme.spacing(19),
    minHeight: theme.spacing(3),
    background: 'rgba( 255, 252, 252, 0.1 )',
    backdropFilter: 'blur( 10px )',
    borderRadius: '10px',
    position: 'absolute',
  },
  logo: {
    width: '30%',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      width: '40%',
      marginLeft: 0,
      marginRight: 0,
    },
  },
  metaInfo: {
    textAlign: 'center',
  },
}));

export default useStyles;